import { render, staticRenderFns } from "./ForwardMessage.vue?vue&type=template&id=ce1aea1c&scoped=true&"
import script from "./ForwardMessage.vue?vue&type=script&lang=js&"
export * from "./ForwardMessage.vue?vue&type=script&lang=js&"
import style0 from "./ForwardMessage.vue?vue&type=style&index=0&id=ce1aea1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1aea1c",
  null
  
)

export default component.exports